export const formatCurrency = (value: number, currency = "NOK") =>
  new Intl.NumberFormat("no", { style: "currency", currency }).format(value);

// Use "hard space" (&nbsp;) before percentage sign (https://www.korrekturavdelingen.no/mellomrom.htm)
export const formatPercentage = (value: number) => value && `${value}${"\xa0"}%`;
